interface PerPageMigrationBanner {
  show: () => void;
  hide: () => void;
  isVisible: () => boolean;
}

export const perPageMigrationBanner = ((): PerPageMigrationBanner => {
  const status = {
    isVisible: false,
  };

  return {
    show: () => (status.isVisible = true),
    hide: () => (status.isVisible = false),
    isVisible: () => status.isVisible,
  };
})();
